"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconElectricity = function IconElectricity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M10.198 10.847c7.006-7.359 18.54-7.89 26.19-1.269l.281.25-1.338 1.486c-6.84-6.158-17.339-5.754-23.685.912s-6.236 17.17.249 23.7c6.485 6.531 16.989 6.715 23.698.416 6.62-6.216 7.174-16.515 1.32-23.4l-.24-.278 1.494-1.328c6.828 7.693 6.294 19.423-1.205 26.464-7.499 7.04-19.239 6.835-26.487-.464s-7.37-19.04-.277-26.49M24.5 22.5 29 22l-7 11 1.5-7.5-4.5.5 7-11z"
  })));
};

export { IconElectricity, IconElectricity as default };
